export const EditorialActions = {
    GET_EDITORIAL_SECTIONS: "GET_EDITORIAL_SECTIONS",
    SET_EDITORIAL_SECTIONS: "SET_EDITORIAL_SECTIONS",

    GET_EDITORIALMENU_SECTIONS: "GET_EDITORIALMENU_SECTIONS",
    SET_EDITORIALMENU_SECTIONS: "SET_EDITORIALMENU_SECTIONS",
  };
  